import cabri from "./cabri-app.js";

/**
 * Set of methods about reading from the camera added to the babylon camera object.
 */



/**
 * Get projection to screen in pixel coordinates, from CDK 3D coordinates
 *
 * @param {number} x - X in cm (in the base plane)
 * @param {number} y - Y in cm (in the base plane)
 * @param {number} z - Z in cm (height above the base plane)
 * @returns an array with the first the number of pixels from left and second the number of pixels from top.
 */
function getScreenUnitCoordFromXyz(x, y ,z) {
  const pos3D = new BABYLON.Vector3(x, z, y);
  const pos2D = BABYLON.Vector3.Project(pos3D,
      BABYLON.Matrix.Identity(),
      cabri.camera.getTransformationMatrix(),
      cabri.camera.viewport);
  return [pos2D.x * cabri.canvas.clientWidth, pos2D.y * cabri.canvas.clientHeight];
}

function setCameraProjection() {
  const m = cabri.camera.getTransformationMatrix().m;
  // swap lines and columns 2 and 3
  const p = [ m[0],  m[2],  m[1],  m[3],
              m[8],  m[10], m[9],  m[11],
              m[4],  m[6],  m[5],  m[7],
              m[12], m[14], m[13], m[15] ];
  // enlarge the field of view by making the last component 5 times bigger
  // ... and thus making the other components 5 times smaller
  for(let i=12; i<16; i++) m[i] = m[i]*5;
  cabri.emsc.setProjMatrix(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]);
}

export default {getScreenUnitCoordFromXyz, setCameraProjection}
